import { CompanyProfile, PermissionCompany } from 'models';

import { useCurrentProfile } from 'components/company-profile/hooks/use-current-profile';

const useProfilePermission = (permission: PermissionCompany, fallbackCompany?: CompanyProfile) => {
    const profile = useCurrentProfile();

    return profile?.permissions?.includes(permission) ?? fallbackCompany?.permissions?.includes(permission);
};

export { useProfilePermission };
